var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CartInfoCard',{attrs:{"infoValue":_vm.value,"text":_vm.text,"hideEdit":true,"icon":"$editcalendar","editable":_vm.editable,"isCheckout":_vm.isCheckout},on:{"edit":_vm.edit}})}
var staticRenderFns = []

export { render, staticRenderFns }